import styled from "styled-components";

export const BookingContainerStyled = styled.div`
  padding: 20px 20px 40px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .booking_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .section {
      .activity_wrap {
        margin-bottom: 22px;
        .act_img {
          width: 100%;
          height: auto;
        }
      }
      .status_wrap {
        .title {
          margin-bottom: 16px;
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        }
        .detail {
          margin-bottom: 22px;
          width: 95%;
          color: ${({ theme }) => theme.COLORS.PURPLE_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
          white-space: pre-wrap;
          &.bd {
            color: ${({ theme }) => theme.COLORS.PURPLE_1};
            font-size: ${({ theme }) => theme.FONT.SIZE.S14};
            font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
            span {
              color: ${({ theme }) => theme.COLORS.PURPLE_1};
              font-size: ${({ theme }) => theme.FONT.SIZE.S14};
              font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
              text-decoration: none;
            }
          }
        }
      }
      .btn_wrap {
        margin: auto;
        margin-bottom: 17px;
        width: 100%;
        max-width: 298px;
        .btn {
          padding: 10px 20px;
        }
        .gold_btn {
          border: 1px solid ${({ theme }) => theme.COLORS.YELLOW_2};
          border-radius: 50px;
          padding: 8px;
          width: 100%;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${({ theme }) => theme.COLORS.WHITE_1};
          color: ${({ theme }) => theme.COLORS.YELLOW_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S18};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
        }
      }
    }

    .desc {
      margin-bottom: 30px;
      width: 100%;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      white-space: pre-wrap;
    }

    .status_detail {
      border: 1px solid ${({ theme }) => theme.COLORS.BLACK_1};
      padding: 15px 20px;
      .title {
        margin-bottom: 15px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }

      .detail_status {
        width: 100%;
        .status {
          margin-bottom: 20px;
          border-radius: 24px;
          padding: 7px 30px;
          text-align: center;
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
          &.orange {
            background: #ff8900;
            color: ${({ theme }) => theme.COLORS.WHITE_1};
          }
          &.yellow {
            background: #fff500;
            color: ${({ theme }) => theme.COLORS.PURPLE_1};
          }
          &.green {
            background: #3f830d;
            color: ${({ theme }) => theme.COLORS.WHITE_1};
          }
        }
      }
      .detail {
        margin-bottom: 15px;
        margin-left: 10px;
        display: flex;
        .detail_left {
          .title_detail {
            margin-bottom: 5px;
            color: ${({ theme }) => theme.COLORS.PURPLE_11};
            font-size: ${({ theme }) => theme.FONT.SIZE.S14};
            font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
            text-wrap: nowrap;
          }
        }
        .detail_right {
          margin-left: 20px;
          overflow: hidden;
          .sub_title {
            margin-bottom: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: ${({ theme }) => theme.COLORS.PURPLE_1};
            font-size: ${({ theme }) => theme.FONT.SIZE.S14};
            font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
            &.hightlight {
              font-size: ${({ theme }) => theme.FONT.SIZE.S16};
              font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
            }
          }
        }
      }
      .remark {
        color: ${({ theme }) => theme.COLORS.RED_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        margin-bottom: 10px;
      }
      .qr_sec {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 30px;
      }
      .btn_wrap {
        width: 100%;
        max-width: 215px;
      }
    }
    .btn_back {
      width: 171px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 20px 40px 20px;
    .breadcrumb_layout {
      display: none;
    }
    .booking_container {
      .status_detail {
        padding: 10px 15px;
      }
    }
  }
`;
